// CDN mapping for video files
const cdnMapping = {
  "text2video/panowan/wild west town.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/wild west town-5c36fb15.mp4",
  "text2video/panowan/volcano.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/volcano-42722bce.mp4",
  "text2video/panowan/underwater reef.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/underwater reef-0e3f8d1b.mp4",
  "text2video/panowan/train journey.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/train journey-7fcf1ba7.mp4",
  "text2video/panowan/starbucks.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/starbucks-a43fc9ca.mp4",
  "text2video/panowan/ski resort.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/ski resort-7dbe5a82.mp4",
  "text2video/panowan/oasis.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/oasis-55688d5d.mp4",
  "text2video/panowan/medieval reenactment.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/medieval reenactment-debaa4b0.mp4",
  "text2video/panowan/lake.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/lake-3e64024d.mp4",
  "text2video/panowan/hot spring.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/hot spring-d991f9cf.mp4",
  "text2video/panowan/hot pot restaurant.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/hot pot restaurant-97c5fe5c.mp4",
  "text2video/panowan/desert.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/desert-f7af187e.mp4",
  "text2video/panowan/cyberpunk.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/cyberpunk-fcb4cda3.mp4",
  "text2video/panowan/concert festival.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/concert festival-4c0a4096.mp4",
  "text2video/panowan/Canyon.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/panowan/Canyon-88c244e8.mp4",
  "text2video/dynamicscaler/wild west town.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/wild west town-7525aca2.mp4",
  "text2video/dynamicscaler/volcano.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/volcano-bbb1307d.mp4",
  "text2video/dynamicscaler/underwater reef.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/underwater reef-dcfef0b6.mp4",
  "text2video/dynamicscaler/train journey.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/train journey-b7d5cb5c.mp4",
  "text2video/dynamicscaler/starbucks.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/starbucks-04982afe.mp4",
  "text2video/dynamicscaler/ski resort.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/ski resort-178c112f.mp4",
  "text2video/dynamicscaler/oasis.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/oasis-96e2c91b.mp4",
  "text2video/dynamicscaler/medieval reenactment.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/medieval reenactment-f53d5993.mp4",
  "text2video/dynamicscaler/lake.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/lake-6999e96d.mp4",
  "text2video/dynamicscaler/hot spring.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/hot spring-2203492d.mp4",
  "text2video/dynamicscaler/hot pot restaurant.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/hot pot restaurant-c501c760.mp4",
  "text2video/dynamicscaler/desert.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/desert-12e63132.mp4",
  "text2video/dynamicscaler/cyberpunk.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/cyberpunk-db736eb4.mp4",
  "text2video/dynamicscaler/concert festival.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/concert festival-37bea262.mp4",
  "text2video/dynamicscaler/Canyon.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/dynamicscaler/Canyon-ba6dcdda.mp4",
  "text2video/360dvd/wild west town.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/wild west town-95a541b4.mp4",
  "text2video/360dvd/volcano.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/volcano-bf35e7f2.mp4",
  "text2video/360dvd/underwater reef.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/underwater reef-4aeda166.mp4",
  "text2video/360dvd/train journey.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/train journey-d9be38bf.mp4",
  "text2video/360dvd/starbucks.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/starbucks-62688ca7.mp4",
  "text2video/360dvd/ski resort.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/ski resort-42d31446.mp4",
  "text2video/360dvd/oasis.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/oasis-354115d1.mp4",
  "text2video/360dvd/medieval reenactment.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/medieval reenactment-285f3a44.mp4",
  "text2video/360dvd/lake.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/lake-52831a67.mp4",
  "text2video/360dvd/hot spring.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/hot spring-8019bbf7.mp4",
  "text2video/360dvd/hot pot restaurant.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/hot pot restaurant-1b444975.mp4",
  "text2video/360dvd/desert.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/desert-235b008e.mp4",
  "text2video/360dvd/cyberpunk.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/cyberpunk-b19f2169.mp4",
  "text2video/360dvd/concert festival.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/concert festival-2cba97d8.mp4",
  "text2video/360dvd/Canyon.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/text2video/360dvd/Canyon-bed31c32.mp4",
  "heros/snowy summit.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/heros/snowy summit-7980f4f9.mp4",
  "heros/horse ranch.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/heros/horse ranch-83e85528.mp4",
  "heros/futuristic city.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/heros/futuristic city-c5d9dceb.mp4",
  "heros/bicycle marathon.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/heros/bicycle marathon-a9cfec31.mp4",
  "heros/aurora borealis.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/heros/aurora borealis-d86de979.mp4",
  "applications/sr/lr/artisan bakery.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/applications/sr/lr/artisan bakery-6f42be20.mp4",
  "applications/sr/hr/artisan bakery.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/applications/sr/hr/artisan bakery-a904c664.mp4",
  "applications/semantic_editing/original.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/applications/semantic_editing/original-f156478d.mp4",
  "applications/semantic_editing/inpainted.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/applications/semantic_editing/inpainted-a650be9a.mp4",
  "applications/outpainting/raw.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/applications/outpainting/raw-105ef61c.mp4",
  "applications/outpainting/outpainting.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/applications/outpainting/outpainting-770fccd4.mp4",
  "applications/long_videos/beach.mp4":
    "https://pub-37dbc81d04204d8eb96319d304eb516d.r2.dev/applications/long_videos/beach-4bdf9044.mp4",
};

// Helper function to get CDN URL for a video path
export function getCdnUrl(videoPath) {
  // Remove leading slash if present
  const cleanPath = videoPath.startsWith("/")
    ? videoPath.substring(1)
    : videoPath;

  // Check if path exists in mapping
  if (cdnMapping[cleanPath]) {
    return cdnMapping[cleanPath];
  }

  // If not found, return original path (fallback)
  return videoPath;
}

export default cdnMapping;
